import { useLoginForm } from '../../../hooks/auth/useLoginForm';
import { useLoginRestaurant } from '../../../hooks/auth/useLoginRestaurant';
import { LoginForm } from '../../organisms/authentication/LoginForm';


export const LoginRestaurant = () => {
  const { handleSubmit, register, isSubmitting, errors } = useLoginForm();
  const onSubmit = useLoginRestaurant();
  return <LoginForm onSubmit={handleSubmit(onSubmit)} register={register} errors={errors} isSubmitting={isSubmitting} title="店舗ログイン" btnColor="messenger" />
};